/**
 * Privilege Levels Configuration
 * Definicija nivoa privilegija za korisnike aplikacije
 */

export const PRIVILEGE_LEVELS = [
  {
    value: 0,
    label: "Pregledač",
    description: "Može samo pregledati podatke",
  },
  { value: 1, label: "Korisnik", description: "Standardni pristup" },
  { value: 7, label: "Administrator", description: "Puni pristup sistemu" },
  {
    value: 5,
    label: "Organizator",
    description: "Upravljanje korisnicima i resursima",
  },
];

/**
 * Vraća tekstualni prikaz za nivo privilegija
 * @param {number} level - Numerički nivo privilegija
 * @returns {string} - Tekstualni naziv nivoa
 */
export function getPrivilegeLevelLabel(level) {
  const found = PRIVILEGE_LEVELS.find((p) => p.value === level);
  return found ? found.label : `Nepoznat (${level})`;
}

/**
 * Vraća nivo privilegija za vue-select opcije
 * @returns {Array} - Niz objekata za vue-select
 */
export function getPrivilegeLevelOptions() {
  return PRIVILEGE_LEVELS.map((p) => ({
    id: p.value,
    name: p.label,
    description: p.description,
  }));
}
